var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.4594C21 11.7801 20.9403 11.127 20.8295 10.5H12V14.2054H17.0455C16.8281 15.4028 16.1676 16.4173 15.1747 17.0965V19.5H18.2045C19.9773 17.8324 21 15.3766 21 12.4594Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0433 21.5C14.4734 21.5 16.5108 20.7262 18 19.4063L15.0912 17.2379C14.2852 17.7565 13.2542 18.0629 12.0433 18.0629C9.69901 18.0629 7.71479 16.5426 7.00701 14.5H4V16.7391C5.48101 19.5634 8.52484 21.5 12.0433 21.5Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14.1923C6.81837 13.6579 6.71517 13.087 6.71517 12.5C6.71517 11.913 6.81837 11.3421 7 10.8077V8.5H3.96594C3.35088 9.70243 3 11.0628 3 12.5C3 13.9372 3.35088 15.2976 3.96594 16.5L7 14.1923Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0058 6.93715C13.3211 6.93715 14.502 7.37318 15.4305 8.22952L18 5.75084C16.4485 4.35634 14.4206 3.5 12.0058 3.5C8.50378 3.5 5.47411 5.43659 4 8.26094L6.99302 10.5C7.6975 8.45735 9.67248 6.93715 12.0058 6.93715Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e38c45d97379e1f9c2bc57e68892d4ec.svg";
export { ForwardRef as ReactComponent };